import localforage from 'localforage';
import { setToken as httpSetToken } from 'apsis-plugin';
import * as CONFIG from '../../../config';
import { loginStore } from './index';

export default () => {
  const cfgSubscribe = loginStore();
  cfgSubscribe.$subscribe((mutation, state) => {
    /**
     * Set the Axios Authorization header with the token
     */
    httpSetToken(state.token);

    /**
     * Sets the token to the local storage
     * for auto-login purpose
     */
    localforage.setItem(CONFIG.userTokenStorageKey, state.token);
    localforage.setItem(CONFIG.userOperadoraStorageKey, state.operadora);
    localforage.setItem(CONFIG.userPrestadorStorageKey, state.prestador);
    localforage.setItem(CONFIG.userAdminStorageKey, state.admin);
    localforage.setItem(CONFIG.userPermissionsStorageKey, state.permissions);
  }, { detached: true });
};
